export function Skeleton({ className = "" }) {
  return <div className={`animate-pulse rounded-md bg-secondary ${className}`} />;
}

export function StatCardsSkeleton({ count = 4 }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="loading-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-card border border-border rounded-lg p-5">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-8 w-12 mt-3" />
        </div>
      ))}
    </div>
  );
}

export function PanelsSkeleton({ count = 6 }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-5" data-testid="loading-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-card border border-border rounded-lg p-5">
          <div className="flex items-center gap-2.5 mb-4">
            <Skeleton className="h-8 w-8 rounded-lg" />
            <Skeleton className="h-4 w-32" />
          </div>
          <Skeleton className="h-3 w-full mb-2" />
          <Skeleton className="h-3 w-4/5 mb-2" />
          <Skeleton className="h-3 w-2/3" />
        </div>
      ))}
    </div>
  );
}

export function TableSkeleton({ rows = 6 }) {
  return (
    <div className="bg-card border border-border rounded-lg p-4 space-y-3" data-testid="loading-skeleton">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-4">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-4 w-24 ml-auto" />
          <Skeleton className="h-5 w-16 rounded-full" />
        </div>
      ))}
    </div>
  );
}

export function CardSkeleton({ lines = 4 }) {
  return (
    <div className="bg-card border border-border rounded-xl p-6 space-y-3" data-testid="loading-skeleton">
      <Skeleton className="h-6 w-1/3" />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={`h-4 ${i % 2 ? "w-2/3" : "w-5/6"}`} />
      ))}
    </div>
  );
}
